import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import css from '../nibTable.module.sass';

const Remove = ({ onClick = () => {}, status, ...props }) => {
  return (
    <div className={css.edit}>
      <IconButton onClick={onClick}>
        <DeleteForeverIcon />
      </IconButton>
    </div>
  );
};

export default Remove;
